

























import Vue from "vue";
import Component from "vue-class-component";
import NewsSWiper from "./components/NewsSwiper.vue";
import System from "./components/System.vue";
import CertificationRequirements from "./components/CertificationRequirements.vue";
import DataCard from "./components/DataCard.vue";
import pencilUrl from "../../assets/images/pencil.png";
import teacher from "../../assets/images/teacher.png";
import studentBg from "../../assets/images/student-login-bg.png";
import teacherBg from "../../assets/images/teacher-login-bg.png";
import document from "../../assets/images/document.png";
import policyIcon from "../../assets/images/policy-icon.png";
import downloadIcon from "../../assets/images/download-icon.png";
@Component({
  components: {
    NewsSWiper,
    System,
    CertificationRequirements,
    DataCard
  }
})
export default class Home extends Vue {
  private loading = true;
  private systemList: any = [
    {
      icon: pencilUrl,
      title: "知识竞答系统",
      info: "用户登录",
      backgroundUrl: studentBg,
      titleColor: "#FFFFFF",
      infoColor: "#FFFFFF",
      path: ""
    },
    {
      icon: teacher,
      title: "评审管理系统",
      info: "专家登录",
      backgroundUrl: teacherBg,
      titleColor: "#1063AD",
      infoColor: "#1563AD",
      path: ""
    }
  ];
  // 新闻中心内容
  private newsList = {
    title: "新闻中心",
    icon: document,
    list: []
  };
  // 政策公告
  private policyList = {
    title: "政策公告",
    icon: policyIcon,
    list: []
  };
  // 资料下载
  private dataList = {
    title: "资料下载",
    icon: downloadIcon,
    list: []
  };
  async created() {
    this.loading = true;
    await this.getNewsList();
    await this.getSystemUrl();
    this.loading = false;
  }
  // 新闻列表
  private async getNewsList() {
    const res = await this.$axios("getNewsList", {
      page: 1,
      limit: 99999,
      isPublished: 1
    });
    this.newsList.list = res.data.data.list.filter(v => v.type == "NEWS");
    this.policyList.list = res.data.data.list.filter(v => v.type == "POLICY");
    this.dataList.list = res.data.data.list.filter(
      v => v.type == "DATA_DOWNLOAD"
    );
  }
  // 获取登陆链接
  private async getSystemUrl() {
    const { data } = await this.$axios("getSystemUrl");
    this.systemList[0].path = data.data.studentSystemUrl;
    this.systemList[1].path = data.data.orgizationSystemUrl;
  }
  // 跳转证书查询页面
  private goCertificate() {
    this.$router.push("/certificateQuery");
  }
}
